import { Outlet, useLocation } from 'react-router-dom';
import { CountrySelect } from 'components/filter/input/CountrySelect';
import { BrandSelect } from 'components/filter/input/BrandSelect';
import { MarketplaceSelect } from 'components/filter/input/MarketplaceSelect';
import { InfoButton } from 'components/InfoButton';
import { PageHeader } from 'components/Layout/PageContainer';
import { useEffect, useState } from 'react';
import { InsightsDateRangePicker } from 'components/filter/modules/insights';
import { FilterDialogButton } from 'components/filter/advancedFilter';
import { useTransitiveCacheStore } from 'hooks/state/useTransitiveCacheStore';

export function Profitability() {
  const location = useLocation();
  const [pathName, setPathName] = useState('');

  useEffect(() => {
    if (location) {
      const page = location.pathname.slice(location.pathname.lastIndexOf('/'), location.pathname.length);
      setPathName(page);
    }
  }, [location]);

  const { hiddenFilters } = useTransitiveCacheStore();

  const isDateRangeHidden = hiddenFilters?.includes('dateRange') ?? false;
  const isComparisonDateRangeHidden = hiddenFilters?.includes('comparisonDateRange') ?? false;

  return (
    <div className="max-w-none insights-pro">
      {pathName !== '/cost-configurations' && (
        <PageHeader topRightComponent={<InfoButton tooltipText="View profitability information" showText />}>
          {!isDateRangeHidden && <InsightsDateRangePicker.Default caption="filter.key.selectedDateRange" />}
          {!isComparisonDateRangeHidden && (
            <InsightsDateRangePicker.Comparison caption="filter.key.selectedDateRangeComparison" />
          )}
          <CountrySelect />
          <BrandSelect />
          <MarketplaceSelect />
          <FilterDialogButton module="insights" />
        </PageHeader>
      )}
      <Outlet />
    </div>
  );
}
